import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const localStorageAuth: string | null = localStorage.getItem(`${process.env.VUE_APP_NAME}_auth`);
const initialState: UserState = {
    auth: (localStorageAuth) ? JSON.parse(localStorageAuth) : undefined,
};

const getters: GetterTree<UserState, RootState> = {
    auth(state: UserState): Auth | undefined {
        return state.auth;
    },
};

const mutations: MutationTree<UserState> = {
    RESET(state: UserState) {
        localStorage.clear();
        state.auth = undefined;
    },
    SET_AUTH(state: UserState, payload: Auth) {
        state.auth = payload;
    },
    STORE_AUTH(state: UserState, payload: Auth) {
        localStorage.setItem(`${process.env.VUE_APP_NAME}_auth`, JSON.stringify(payload));
    },
};

const actions: ActionTree<UserState, RootState> = {
    login({ commit, rootState }, payload: LoginPayload) {
        return rootState.api.post('api/login', payload, { withCredentials: true })
            .then((response: { data: {} }) => {

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    register({ commit, rootState }, payload: RegisterPayload) {
        return rootState.api.post('api/register', payload)
            .then((response: { data: Auth }) => {
                commit('SET_AUTH', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    me({ commit, rootState, state }, dontUseStorage: boolean | undefined) {

        if (state.auth && !dontUseStorage) {
            return new Promise((resolve) => resolve(state.auth));
        }

        return rootState.api.get('api/me', { withCredentials: true })
            .then((response: { data: Auth }) => {
                commit('SET_AUTH', response.data);

                commit('STORE_AUTH', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    logout({ commit, rootState }) {
        return rootState.api.post('api/logout', {}, { withCredentials: true })
            .then((response: { data: Auth }) => {
                commit('RESET');

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};
